/** @jsx h */

import React from 'react';
import { h, Component, Fragment, createRef } from "preact";
import fetch from 'cross-fetch';
import { getDispatchDay, addBusinessDays, getShippingData } from '@/scripts/utils/shipping'

class shippingEstimate extends Component {
  constructor(props) {
    super(props);
    this.cutoffHour = window.SHIPPING_SETTINGS.cutoffHour;
    this.dispatchCountry = window.SHIPPING_SETTINGS.dispatchCountry;
    this.countries = window.SHIPPING_SETTINGS.countriesForHolidayChecking;
    this.showShippingEstimateCountries = window.SHIPPING_SETTINGS.showShippingEstimateCountries;

    this.carrier = {
      code: 'FEDEX',
      message: 'Fully trackable with SMS updates',
    }

    this.state = {
      carriers: [],
      carrierSelected: null,
      shippingMessage: '',
      country: 'us'
    };

    this.getSettingsByLocation((shippingData) => {
      this.setMessage(shippingData);
    })
  }

  componentDidMount() {
    this.setShippingEstimateVisibility();
  }

  setMessage = (shippingData) => {
    var message = '';

    if (shippingData) {
      const shippingMethod = shippingData['shipping_method'];
      const dispatchDay = getDispatchDay(this.dispatchCountry, this.cutoffHour);

      // Calculate early delivery date
      const earlyDate = addBusinessDays(dispatchDay, shippingData[shippingMethod]['minDeliveryDays'], this.countries);

      // Calculate late delivery date
      const lateDate = addBusinessDays(dispatchDay, shippingData[shippingMethod]['maxDeliveryDays'], this.countries);

      var dateRange = lateDate > earlyDate ? `${earlyDate.format('ddd, MMM DD')} - ${lateDate.format('ddd, MMM DD')}` : lateDate.format('ddd, MMM DD');

      message = shippingData['message'].replace('[DATE_RANGE]', dateRange);
      message = message.replace('<br>', '&nbsp;');

      this.setState({
        shippingMessage: message
      });
    }
  }

  getSettingsByLocation = (callback) => {
    this.getCountryCode((countryCode) => {
      const shippingData = getShippingData(window.SHIPPING_SETTINGS, countryCode)

      callback(shippingData)
    })
  }

  getCountryCode = (callback) => {
    if (window.countryCode) {
      callback(window.countryCode.toLowerCase())
    } else {
      callback('us')
    }
  }

  setShippingEstimateVisibility = () => {
    let giftCardCount = 0;

    if(CartJS.cart.items) {
      CartJS.cart.items.map((each)=>{
        if(each.properties.PREORDER){
          $('#js-cartShippingEstimate').hide();
        }

        if (each.gift_card) {
          giftCardCount ++
        }
      })

      if (giftCardCount == CartJS.cart.items.length) {
        $('#js-cartShippingEstimate').hide();
      }
    }
  }

  render() {
    return (
      this.showShippingEstimateCountries.length > 0 && this.showShippingEstimateCountries.includes(window.countryCode) ?
        <div class="c-shippingEstimate">
          <span class="c-shippingCarIcon">
            <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1">
                <title>Group</title>
                <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Cart-Shipping" transform="translate(-1180.000000, -446.000000)" fill="#000000" fill-rule="nonzero">
                        <g id="bottom" transform="translate(884.000000, 266.000000)">
                            <g id="Group" transform="translate(296.000000, 180.000000)">
                                <path d="M15.862069,4.47058824 L15.1034483,2.47058824 C14.8275862,1.74509804 14.2068966,1.2745098 13.5,1.2745098 L12.2758621,1.2745098 L12.2758621,0.764705882 C12.2758621,0.352941176 11.9827586,0 11.6034483,0 L3.05172414,0 C2.79310345,0 2.60344828,0.235294118 2.60344828,0.509803922 C2.60344828,0.784313725 2.81034483,1.01960784 3.05172414,1.01960784 L11.3448276,1.01960784 L11.3448276,4.78431373 C11.3448276,5.25490196 11.6724138,5.62745098 12.0862069,5.62745098 L15.0689655,5.62745098 L15.0689655,8 C15.0689655,8.09803922 15,8.17647059 14.9137931,8.17647059 L14.362069,8.17647059 C14.0689655,7.60784314 13.5344828,7.23529412 12.9310345,7.23529412 C12.3275862,7.23529412 11.7931034,7.62745098 11.5,8.17647059 L6.89655172,8.17647059 C6.60344828,7.60784314 6.06896552,7.23529412 5.46551724,7.23529412 C4.86206897,7.23529412 4.32758621,7.62745098 4.03448276,8.17647059 L2.44827586,8.17647059 C2.18965517,8.17647059 2,8.41176471 2,8.68627451 C2,8.98039216 2.20689655,9.19607843 2.44827586,9.19607843 L3.81034483,9.19607843 C3.84482759,10.1960784 4.56896552,11 5.46551724,11 C6.36206897,11 7.0862069,10.1960784 7.12068966,9.19607843 L11.2758621,9.19607843 C11.3103448,10.1960784 12.0344828,11 12.9310345,11 C13.8275862,11 14.5517241,10.1960784 14.5862069,9.19607843 L14.9482759,9.19607843 C15.5344828,9.19607843 16,8.64705882 16,8 L16,5.25490196 C16,5 15.9482759,4.7254902 15.862069,4.47058824 Z M5.46551724,9.98039216 C5.05172414,9.98039216 4.70689655,9.58823529 4.70689655,9.11764706 C4.70689655,8.64705882 5.05172414,8.25490196 5.46551724,8.25490196 C5.87931034,8.25490196 6.22413793,8.64705882 6.22413793,9.11764706 C6.22413793,9.58823529 5.87931034,9.98039216 5.46551724,9.98039216 Z M12.9310345,9.98039216 C12.5172414,9.98039216 12.1724138,9.58823529 12.1724138,9.11764706 C12.1724138,8.64705882 12.5172414,8.25490196 12.9310345,8.25490196 C13.3448276,8.25490196 13.6896552,8.64705882 13.6896552,9.11764706 C13.6896552,9.58823529 13.3448276,9.98039216 12.9310345,9.98039216 Z M12.2586207,2.31372549 L13.4827586,2.31372549 C13.8103448,2.31372549 14.1206897,2.52941176 14.2413793,2.88235294 L14.8965517,4.60784314 L12.2586207,4.60784314 L12.2586207,2.31372549 Z" id="Shape"></path>
                                <path d="M2.44067797,3 L5.55932203,3 C5.81355932,3 6,2.76923077 6,2.5 C6,2.21153846 5.79661017,2 5.55932203,2 L2.44067797,2 C2.18644068,2 2,2.23076923 2,2.5 C2,2.76923077 2.20338983,3 2.44067797,3 Z" id="Path"></path>
                                <path d="M1.44067797,5 L4.55932203,5 C4.81355932,5 5,4.76923077 5,4.5 C5,4.21153846 4.79661017,4 4.55932203,4 L1.44067797,4 C1.18644068,4 1,4.23076923 1,4.5 C1,4.76923077 1.20338983,5 1.44067797,5 Z" id="Path"></path>
                                <path d="M4,6.4994403 C4,6.21130166 3.79746835,6 3.56118143,6 L0.438818565,6 C0.185654008,6 0,6.23051091 0,6.4994403 C0,6.78757893 0.202531646,6.9988806 0.438818565,6.9988806 L3.5443038,6.9988806 C3.79746835,7.01808984 4,6.78757893 4,6.4994403 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          </span>

          <div dangerouslySetInnerHTML={{ __html: this.state.shippingMessage }}></div>
        </div>

      : ''
    );
  }
}

export default shippingEstimate;
